import { useMemo } from 'react'
import {
  Title,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalCloseButton,
  Body,
  CopyButton,
} from '@panwds/react-ui'

import type { VFC } from 'react'
import type { RenderModalProps } from '@panwds/react-ui'
import { Bold } from '@panwds/react-ui-legacy'
import { BUTTON_COPY, ERROR_RESOLUTION_SUBTEXT, LINK_SUPPORT_CASE } from '../../tenancy/constants/LabelConstants'
import StringTemplate from '../../common/utils/StringTemplate'

type ContractModalProps = {
  displayInfo: {
    support_account_id: string,
    support_account_name: string,
    csp_serial_number: string,
    license_id: string,
  }
}

const TITLE = 'View Support Information'

const keyDisplayMap = new Map([
  ['support_account_id', 'Support Account ID'],
  ['support_account_name', 'Support Account Name'],
  ['csp_serial_number', 'Contract Number'],
  ['license_id', 'License ID']
])
const ContractModal: VFC<RenderModalProps & ContractModalProps> = (props) => {
  const { isOpen, closeModal, displayInfo } = props

  const table = useMemo(() => {
    return (
      <table className="cm-w-full cm-mt-2 cm-mb-4" style={{ tableLayout: 'fixed' }}>
        <tbody>
          {Object.entries(displayInfo).map(([key, value]) => {
            return (
              <tr key={key}>
                <td className="cm-align-top"><Bold>{keyDisplayMap.get(key)}</Bold></td>
                <td className="cm-align-top" style={{ width: '60%' }}>{value}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }, [displayInfo])

  const copyBtn = useMemo(() => {
    return (
      <CopyButton
        text={JSON.stringify(displayInfo, null, 2)}
        appearance="secondary"
      >{BUTTON_COPY}</CopyButton>
    )
  }, [displayInfo])

  return (
    <Modal size='md' confirmClose={false} onClose={closeModal} isOpen={isOpen}>
      <ModalHeader title={TITLE} enableClose />
      <ModalBody addClassName='cm-overflow-auto cm-scrollbar-default dark:cm-scrollbar-track-dark dark:cm-scrollbar-thumb-dark'>
        <Title level={2} size='xxs' addClassName='cm-mb-2'>Product Information: </Title>
        {table}
        {copyBtn}
        <Body addClassName="cm-mt-2 cm-mb-2" size="lg">{StringTemplate(ERROR_RESOLUTION_SUBTEXT, (
          <><br />
            <a
              href="https://supportcases.paloaltonetworks.com/"
              target="_blank"
              rel="noopener noreferrer">{LINK_SUPPORT_CASE}</a>
          </>
        ))}</Body>
      </ModalBody>
      <ModalFooter>
        <ModalCloseButton>Close</ModalCloseButton>
      </ModalFooter>
    </Modal>
  )
}

export default ContractModal
